import * as React from "react";
function SvgOutbreak(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M2.5 23.5H1.3c-.8 0-1.3.5-1.3 1.2S.5 26 1.3 26h1.3c.8 0 1.3-.5 1.3-1.3s-.6-1.2-1.4-1.2zm7.6 2.5h1.3c.8 0 1.3-.5 1.3-1.3s-.5-1.3-1.3-1.3h-1.3c-.8 0-1.3.5-1.3 1.3s.7 1.3 1.3 1.3zm8.8 0h1.3c.8 0 1.3-.5 1.3-1.3s-.5-1.3-1.3-1.3h-1.3c-.8 0-1.3.5-1.3 1.3s.7 1.3 1.3 1.3zm19-2.5h-1.3c-.8 0-1.3.5-1.3 1.3s.5 1.3 1.3 1.3h1.3c.8 0 1.3-.5 1.3-1.3s-.5-1.3-1.3-1.3zm8.8 0h-1.3c-.8 0-1.3.5-1.3 1.3s.5 1.3 1.3 1.3h1.3c.8 0 1.3-.5 1.3-1.3s-.5-1.3-1.3-1.3zM35 6.8L19.5 35.5l-7.6-6.3-5.8 10.1c-.4.6-.1 1.4.5 1.8.6.4 1.4.1 1.8-.5l4.3-7.6 7.6 6.3 7.3-13.4h1.6c.8 0 1.3-.5 1.3-1.3s-.5-1.3-1.3-1.3h-.3L35 12.2l3.9 8c.3.6 1 .9 1.6.6.6-.3.9-1 .6-1.6V19C41.2 19 35 6.8 35 6.8z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgOutbreak);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
